import styles from './OptimizationDetailsSection.module.scss';

import React from 'react';
import Link from 'gatsby-link';
import RetinaImage from 'src/components/RetinaImage';
import { Button, Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';

import ImgLaptopZoneAndWeight from 'src/images/img-laptop-zone-and-weight.png';
import ImgLaptopZoneAndWeight2x from 'src/images/img-laptop-zone-and-weight@2x.png';

export default (props) => (
  <div styleName='optimization-details-section'>
      <Container>
          <div styleName='text-container'>
              <div className='h2'>Save up to 40% on shipping</div>
              <div className='h2 text-blue'>Let our experts get to work.</div>
              <div styleName='features-table'>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Rate benchmarking</div>
                      <div>
                          See how your rates stack up against the market. We’ll
                          run a preliminary savings estimate for you at no cost
                          and with no commitment.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Service configuration</div>
                      <div>
                          Discover the perfect shipping setup. Based on your
                          requirements, we’ll craft a plan &mdash; carriers,
                          services, and routing logic &mdash; that will delight
                          your customers and terrify your competitors.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Assisted negotiations</div>
                      <div>
                          Let us do the heavy lifting. Our team of experts will
                          guide you through the complex negotiation process and
                          quantify your savings before you sign any new carrier
                          contracts.
                      </div>
                  </div>
              </div>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgLaptopZoneAndWeight, ImgLaptopZoneAndWeight2x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/OptimizationDetailsSection.js